// COIN_dashboard\client\src\components\side-navbar\DashboardSideNavBar.js

// Side navbar icons need to be fixed ?

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import user from "../../StyleCSS/icons/user.png";
import signOut_icon from "../../StyleCSS/icons/signOut.png";
import "../../StyleCSS/SideNavbar.css";
import { logout } from "../../reducers/authUserSlice";
import { useDispatch } from "react-redux";
import EvisensLogo from "../logo/EvisensLogo";

function SideNavBar(props) {
  const {
    routes,
    showPortfolioSelector = false,
    portfolioClients = [],
    selectedPortfolio = "",
    onPortfolioChange,
    onLoadPortfolio,
  } = props;

  const [selectedRoute, setSelectedRoute] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // if location changes, update selected route which decides which item to highlight.
    let route = location.pathname.match(/\/dashboard\/(.*)/);
    if (route && route.length >= 2) {
      setSelectedRoute(route[1]);
    } else {
      setSelectedRoute(null);
    }
  }, [location]);

  return (
    <div id="MainNavContainerDashBoard">
      <EvisensLogo />
      {/* Portfolio selector – visible only when customer has 2+ portfolios */}
      {showPortfolioSelector && (
        <div className="nav-portfolio-selector">
          <select
            value={selectedPortfolio}
            onChange={(e) => onPortfolioChange?.(e.target.value)}
            className="nav-portfolio-dropdown"
            title="Välj portfölj"
          >
            <option value="">Välj portfölj</option>
            {portfolioClients.map((client) => (
              <option key={client.clientId} value={client.clientId}>
                {client.name}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="nav-portfolio-btn"
            onClick={() => {
              if (selectedPortfolio) {
                onLoadPortfolio?.(selectedPortfolio);
              }
            }}
            disabled={!selectedPortfolio}
            title="Hämta rapport"
          >
            Hämta rapport
          </button>
        </div>
      )}

      <ul id="dashboardUL">
        <div id="overflow-controll">
          {routes
            ? routes.map((path, index) => {
                return (
                  <li key={path.pathName} className="dashListItem">
                    <Link
                      to={path.route_path}
                      className={`dashLink ${
                        selectedRoute === path.route_path ? "dashLink--active" : ""
                      }`}
                    >
                      <div className="nav-icon-wrap">
                        <img
                          className="sidemenu-icon"
                          src={path.icon}
                          alt=""
                          width={28}
                          height={28}
                        />
                      </div>
                      <p className="dashBoardTitle">
                        {path.pathName.toUpperCase() !== "ARCHIVE"
                          ? path.pathName
                          : "Arkiv"}
                      </p>
                    </Link>
                  </li>
                );
              })
            : null}
        </div>
      </ul>

      <div id="myAccountItem">
        <div
          className="dashLink"
          id="logoutMenuButton"
          onClick={() => {
            dispatch(logout());
          }}
        >
          <div className="nav-icon-wrap">
            <img 
              id="accImg" 
              src={signOut_icon} 
              alt="" 
              height={28} 
              width={28}
            />
          </div>
          <p className="dashBoardTitle">LOGGA UT</p>
        </div>
      </div>

      {/* KONTOSIDA IMPLEMENTERAS SENARE */}
      {/* <div id="myAccountItem">
        <Link className="dashLink" to={"myaccount"}>
          <div
            className={selectedRoute === "myaccount" ? "circleDiv" : "invisDiv"}
          >
            <img id="accImg" src={user} alt="s" />
          </div>
          <p className="dashBoardTitle">KONTO</p>
        </Link>
      </div> */}
    </div>
  );
}

export default SideNavBar;
